import React from 'react'
import { useIntl } from 'react-intl'

import { useFormContext } from '../../Form'
import { Input, TextInput } from '../../Input'
import { passwordConfirmation, required } from '../../../utils/validations'
import { authenticationMessages } from '@tiltify/ui/translations'

export const PasswordConfirmationInput = () => {
  const { formatMessage } = useIntl()
  const { values } = useFormContext()

  const validate = (value) => {
    if (!value) {
      return required(value, formatMessage)
    }
    return passwordConfirmation(values.password || '', value, formatMessage)
  }

  return (
    <Input
      type='password'
      component={TextInput}
      name='passwordConfirmation'
      label={formatMessage(authenticationMessages.passwordConfirmation)}
      validate={validate}
      required
    />
  )
}
